// The company profile printed on documents (invoices, vouchers, receipts, statements, gate passes).
// Today it comes from the deployment's env (one company per deployment). When the SaaS control plane
// exists, the same shape will come from the signed-in tenant's settings instead.
//
//   REACT_APP_COMPANY_NAME="Acme Shipping LLC"
//   REACT_APP_COMPANY_LOGO_URL="https://…/logo.png"        (optional; the name is printed when empty)
//   REACT_APP_COMPANY_ADDRESS="Street, City, Country"
//   REACT_APP_COMPANY_PHONE="+971 …"
//   REACT_APP_COMPANY_EMAIL="info@…"
//   REACT_APP_COMPANY_WEBSITE="https://…"
//   REACT_APP_COMPANY_COMPLAINTS_WHATSAPP="+971 …"         (optional)
//   REACT_APP_COMPANY_SUPPORT_CONTACTS='[{"name":"Support","phone":"+971 …"}]'   (optional)
const env = process.env;

const parseContacts = (raw) => {
  try {
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((c) => c && (c.name || c.phone)) : [];
  } catch {
    return [];
  }
};

const name = env.REACT_APP_COMPANY_NAME || "Your Company";

export const COMPANY = {
  name,
  logoUrl: env.REACT_APP_COMPANY_LOGO_URL || "",
  address: env.REACT_APP_COMPANY_ADDRESS || "",
  phone: env.REACT_APP_COMPANY_PHONE || "",
  email: env.REACT_APP_COMPANY_EMAIL || "",
  website: env.REACT_APP_COMPANY_WEBSITE || "",
  complaintsWhatsapp: env.REACT_APP_COMPANY_COMPLAINTS_WHATSAPP || "",
  supportContacts: parseContacts(env.REACT_APP_COMPANY_SUPPORT_CONTACTS),
};

/** The website without the protocol, for printing ("acme.com"). */
export const companyWebsiteLabel = () => COMPANY.website.replace(/^https?:\/\//, "").replace(/\/$/, "");
